var storage = {};
function isLocalStorageAvailable() {
    var test = 'test';
    try {
        localStorage.setItem(test, test);
        localStorage.removeItem(test);
        return true;
    }
    catch (e) {
        return false;
    }
}
if (isLocalStorageAvailable()) {
    storage = localStorage;
}
export default {
    checkLocalStorage: function () { return isLocalStorageAvailable(); },
    getItem: function (key) { return storage[key]; },
    setItem: function (key, value) {
        storage[key] = value;
    },
    removeItem: function (key) {
        delete storage[key];
    },
};
